import { createReduxConstants } from '@bibliocommons/utils-redux';

export const FLAG_TYPES = {
  STANDARDS_VIOLATION: 'VIOLATES_APPROPRIATE_USE',
  OFFENSIVE: 'OFFENSIVE',
  SPOILER: 'SPOILER'
};

export const VIOLATION_TYPES = {
  UNRELATED: 'UNRELATED',
  UNLAWFUL: 'UNLAWFUL',
  OBSCENE: 'OBSCENE',
  MARKETING_SCHEME: 'MARKETING_SCHEME',
  ADVERTISING: 'ADVERTISING',
  PRIVACY_VIOLATION: 'PRIVACY_VIOLATION',
  VIRUS: 'VIRUS',
  RIGHTS_VIOLATION: 'RIGHTS_VIOLATION',
  CRIMINAL_ADVICE: 'CRIMINAL_ADVICE'
};

export default createReduxConstants('FLAGS', {
  ADD_FLAG_REQUEST: null,
  ADD_FLAG_SUCCESS: null,
  ADD_FLAG_FAILURE: null
});
